<template>
  <div>
    <sk-search ref="search"></sk-search>

    <template v-if="showSuggestions">
      <section class="query-suggestions">
        <h2>Populäre Suchbegriffe</h2>
        <ul class="suggestion-list">
          <li v-for="query in demoQueries" :key="query">
            <span @click="setQuery(query)" class="button">{{ query }}</span>
          </li>
        </ul>
      </section>

      <section class="promotions" v-if="showPromotions">
        <h2>Aktuelle Angebote und Aktionen</h2>
        <sk-promotions></sk-promotions>
      </section>

      <section>
        <h2>Den StadtKatalog erkunden</h2>
        <ul class="suggestion-list">
          <li><router-link :to="{ name: 'sk-overview'}" class="button">Alles in einer Liste</router-link></li>
          <li><router-link :to="{ name: 'sk-map'}" class="button">Alles auf einer Karte</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: einkaufen + genießen' } }" class="button">Einkaufen + Genießen</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: gesundheit + freizeit' } }" class="button">Gesundheit + Freizeit</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: bildung + kultur' } }" class="button">Bildung + Kultur</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: wohnen + arbeiten' } }" class="button">Wohnen + Arbeiten</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: nachbarschaft' } }" class="button">Nachbarschaft</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: mobilität' } }" class="button">Mobilität</router-link></li>
        </ul>
      </section>

      <section class="something-missing">
        <p>
          Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest eine Dienstleistung an?
          Du kannst schnell und einfach neue Einträge für die StadtKatalog vorschlagen,
          oder Ergänzungen und Korrekturen für bestehende Einträge einreichen.
        </p>
        <p class="suggest-stadtkatalog-entry">
          <a :href="proposalUrl" class="button">
            Eintrag vorschlagen
          </a>
        </p>
      </section>
    </template>

  </div>
</template>

<script>
  import {mapState} from "vuex";
  import StadtKatalogSearch from "@/components/StadtKatalogSearch";
  import StadtKatalogPromotions from "@/components/StadtKatalogPromotions";

  export default {
    name: "frontpage-stadtkatalog",
    components: {
      "sk-search": StadtKatalogSearch,
      "sk-promotions": StadtKatalogPromotions
    },
    data () {
      return {
        demoQueries: ["Arzt", "Apotheke", "Restaurant", "Bäckerei", "Buchhandlung", "Spar", "Coworking"]
      }
    },
    computed: {
      ...mapState([
        "geoFenceName",
        "totalHits",
        "promotionDays",
        "promotionEntries"
      ]),
      showSuggestions: function() {
        return this.totalHits <= 0;
      },
      showPromotions: function() {
        return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
      },
      proposalUrl: function() {
        return `https://app.stadtkatalog.org/stk/proposeEntry${this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : ""}`;
      }
    },
    methods: {
      setQuery(query) {
        // only commit, the watcher in the search component automatically triggers the query
        this.$store.commit("setQuery", query);
        this.$refs.search.focusSearchField();
      }
    },
    created() {
      document.title = STADTKATALOG_CONFIG.siteName;
      this.$store.dispatch("updatePromotionEntries");
    }
  }
</script>

<style lang="scss" scoped>
  section {
    margin: 3rem 0;
    padding: 0 3rem;

    h2 {
      text-align: center;
    }

    p {
      line-height: 1.375rem;
    }
  }

  .something-missing {
    .suggest-stadtkatalog-entry {
      text-align: center;

      .button {
        font-weight: 600;
        padding: 0.75rem 1.25rem;
      }
    }
  }

  .suggestion-list {
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-around;

    li {
      margin-bottom: 0.75rem;
      cursor: pointer;

      .button {
        display: inline-block;
      }
    }
  }

  @media (max-width: 50rem) {
    section {
      margin: 3rem 0;
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FrontPageStadtKatalog.vue